import React, { Component } from "react";
import PropTypes from "prop-types";
import SearchMenu from "./SearchMenu";

import { Item } from "@zendeskgarden/react-menus";

import gql from "graphql-tag";
import { Query } from "react-apollo";

const permissionGroupsQuery = gql`
  query PermissionGroups {
    permissionGroups {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

export default class PermissionGroupMenu extends Component {
  static propTypes = {
    getItemProps: PropTypes.func.isRequired,
    focusedKey: PropTypes.string,
  };

  render() {
    const { getItemProps, focusedKey } = this.props;

    return (
      <Query query={permissionGroupsQuery}>
        {({ loading, error, data }) => {
          if (error) return <SearchMenu.SearchFailure />;

          const { permissionGroups = { edges: [], total: 0 } } = data;

          return permissionGroups.edges.map(({ node: { id, name } }) => (
            <Item
              {...getItemProps({
                key: `permissionGroup-${id}`,
                focused: focusedKey === `permissionGroup-${id}`,
              })}
              data-test-id={`filter-menu-permissionGroup-item-${id}`}
            >
              {name}
            </Item>
          ));
        }}
      </Query>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FilterMenu/PermissionGroupMenu.js